import React from "react";
import Button from "Trackalyze/Button";
import Icon from "Trackalyze/Icon";
import Typo from "Trackalyze/Typo";

const Toolbar = React.forwardRef(({
  action,
  symbol,
  title,
  small,
  elevation,
  className,
  style,
  children,
  onClose,
  ...rest
}, ref) => {
  const classes = [
    "ta-toolbar",
    elevation && "ta-elevation_" + elevation,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <nav ref={ref} className={classes} style={style} data-notitle={!title ? "true" : undefined} data-size={small ? "s" : undefined} {...rest}>
      {action && !action.trailing && (
        <Button
          icon
          iconProps={{
            className: "ta-color-text_on-surface-variant",
            ...action.iconProps,
          }}
          symbol={action.symbol || "close"}
          onClick={action.onClick}
        />
      )}
      {symbol && (
        <Icon
          symbol={symbol}
          className="ta-toolbar_symbol ta-color-text_on-surface-variant"
        />
      )}
      {title && (
        <Typo noWrap type="title" size="m" className="ta-toolbar_label">
          {title}
        </Typo>
      )}

      <div className="ta-toolbar_children">
        {children}
        {action && action.trailing && (
          <Button
            icon
            iconProps={{
              className: "ta-color-text_on-surface-variant",
              ...action.iconProps,
            }}
            symbol={action.symbol || "close"}
            onClick={action.onClick}
          />
        )}
        {onClose && (
          <Button
            symbol="close"
            iconProps={{ className: "ta-color-text_on-surface-variant" }}
            icon
            onClick={() => onClose && onClose()}
          />
        )}
      </div>
    </nav>
  );
});

export default Toolbar;
